(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ml-journal-edit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-journal-edit]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const input = section.querySelector('[data-journal-search]');
      if (!input) return;
      const cards = [...section.querySelectorAll('[data-journal-story]')];
      const buttons = [...section.querySelectorAll('[data-journal-topic]')];
      const labels = JSON.parse(section.querySelector('[data-journal-labels]').textContent);
      let topic = '';
      const normalise = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const apply = () => {
        const terms = normalise(input.value).split(/\s+/).filter(Boolean);
        let count = 0;
        cards.forEach(card => {
          const text = normalise(card.dataset.search);
          const matches = (!topic || card.dataset.topic === topic) && terms.every(term => text.includes(term));
          card.hidden = !matches;
          if (matches) count++;
        });
        section.querySelector('[data-journal-count]').textContent = count === 1 ? labels.single : labels.count.replace('__COUNT__', count);
        section.querySelector('[data-journal-empty]').hidden = count > 0;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        topic = button.dataset.journalTopic;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        apply();
      }));
      input.addEventListener('input', apply);
      input.addEventListener('search', apply);
      section.querySelector('[data-journal-tools]').hidden = false;
      apply();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-shop-by-category"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ml-category-carousel')) {
  customElements.define('ml-category-carousel', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('.ml-shop-category__pagination')) {
        this.initFrame = requestAnimationFrame(() => { if (this.isConnected) this.connectedCallback(); });
        return;
      }
      this.track = this.querySelector('.ml-shop-category__grid');
      this.pagination = this.querySelector('.ml-shop-category__pagination');
      this.cards = [...this.track.children];
      this.buttons = [...this.pagination.querySelectorAll('button')];
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.update = () => {
        const viewport = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const width = this.cards[0]?.getBoundingClientRect().width ?? viewport.width;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const visible = Math.max(1, Math.floor((this.track.clientWidth + gap + 2) / (width + gap)));
        this.lastIndex = Math.max(0, this.cards.length - visible);
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.pagination.hidden = !overflow;
        this.track.classList.toggle('is-draggable', overflow);
        let nearest = 0, distance = Infinity;
        for (let i = 0; i <= this.lastIndex; i++) {
          const rect = this.cards[i]?.getBoundingClientRect();
          if (!rect) continue;
          const delta = Math.abs(rtl ? rect.right - viewport.right : rect.left - viewport.left);
          if (delta < distance) { nearest = i; distance = delta; }
        }
        this.index = nearest;
        this.buttons.forEach((button, index) => {
          button.hidden = index > this.lastIndex;
          if (index === nearest) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      };
      this.moveTo = index => {
        cancelAnimationFrame(this.animationFrame);
        const target = Math.max(0, Math.min(index, this.lastIndex));
        const card = this.cards[target];
        if (!card) return;
        this.target = target;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.track.getBoundingClientRect();
        const rect = card.getBoundingClientRect();
        const start = this.track.scrollLeft;
        const delta = rtl ? rect.right - viewport.right : rect.left - viewport.left;
        this.track.classList.add('is-animating');
        const finish = () => {
          this.track.scrollTo({ left: start + delta, behavior: 'instant' });
          this.track.classList.remove('is-animating');
          this.target = null;
          this.update();
        };
        if (this.reducedMotion.matches || Math.abs(delta) < 1) { finish(); return; }
        let started;
        const tick = now => {
          started ??= now;
          const progress = Math.min((now - started) / 650, 1);
          const eased = progress < .5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
          this.track.scrollTo({ left: start + delta * eased, behavior: 'instant' });
          if (progress < 1) this.animationFrame = requestAnimationFrame(tick);
          else finish();
        };
        this.animationFrame = requestAnimationFrame(tick);
      };
      this.buttons.forEach((button, index) => button.addEventListener('click', () => {
        const current = this.target ?? this.index;
        this.moveTo(current + Math.sign(index - current));
      }, options));
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const direction = (event.key === 'ArrowRight') !== rtl ? 1 : -1;
        this.moveTo((this.target ?? this.index) + direction);
      }, options);
      this.track.addEventListener('wheel', event => {
        const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.shiftKey ? event.deltaY : 0;
        if (!delta || this.pagination.hidden) return;
        event.preventDefault();
        clearTimeout(this.wheelTimer);
        this.wheelTimer = setTimeout(() => { this.wheelActive = false; }, 220);
        if (this.wheelActive) return;
        this.wheelActive = true;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.moveTo((this.target ?? this.index) + Math.sign(delta) * (rtl ? -1 : 1));
      }, { ...options, passive: false });
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0 || !this.track.classList.contains('is-draggable')) return;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, index: this.index, moved: false };
        this.suppressClick = false;
      }, options);
      window.addEventListener('pointermove', event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const dx = event.clientX - this.drag.x;
        const dy = event.clientY - this.drag.y;
        if (!this.drag.moved && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { this.drag = null; return; }
        if (Math.abs(dx) > 6 && !this.drag.moved) {
          cancelAnimationFrame(this.animationFrame);
          this.target = null;
          this.drag.moved = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.remove('is-animating');
        }
        if (this.drag.moved) {
          if (event.cancelable) event.preventDefault();
          const width = this.cards[0]?.getBoundingClientRect().width ?? 0;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = Math.max(-width - gap, Math.min(dx, width + gap));
          this.track.scrollTo({ left: this.drag.left - distance, behavior: 'instant' });
        }
      }, { ...options, passive: false });
      const endDrag = event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const drag = this.drag;
        this.drag = null;
        if (drag.moved) {
          const dx = event.clientX - drag.x;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const threshold = Math.max(30, this.track.clientWidth * .05);
          const direction = event.type === 'pointercancel' || Math.abs(dx) < threshold ? 0 : (dx < 0) !== rtl ? 1 : -1;
          this.suppressClick = true;
          this.track.classList.add('is-animating');
          this.track.classList.remove('is-dragging');
          this.moveTo(drag.index + direction);
        }
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
      };
      window.addEventListener('pointerup', endDrag, options);
      window.addEventListener('pointercancel', endDrag, options);
      this.track.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
      }, { ...options, capture: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) this.moveTo(this.cards.indexOf(event.target.closest('.ml-shop-category__card')));
      }, options);
      this.update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.animationFrame);
      clearTimeout(this.wheelTimer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
